/* eslint-disable import/order */
// import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import styles from "../../styles/modal/modal.module.scss";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function BasicModal({
  open,
  onClose,
  scroll,
  title,
  content,
  noBtnClick,
  yesBtnClick,statusChangeList,menuList,warningIconPreview
}) {
  // const theme = useTheme();
  // const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll={scroll}
      className={styles.cmn_modal}
      aria-labelledby="responsive-dialog-title"
    >
      <Box>
      <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          className={styles.modal_stck_icon}
        >
      {warningIconPreview && <ErrorOutlineIcon className={styles.warnIcon} />} 
      </Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
          className={styles.modal_stck}
        >
          <Typography className={styles.modal_title}>{title}</Typography>
        </Stack>
      </Box>

      <DialogContent>
        <Typography variant="body1"> {content}</Typography>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={styles.btn_stck}
        >
          <Button  onClick={noBtnClick}  className={styles.black_btn}>
            <Typography variant="body1">No</Typography>
          </Button>
         
          {statusChangeList ? 
          <Button onClick={(event) => yesBtnClick(event, menuList)} className={styles.red_btn}>
          <Typography variant="body1">Yes</Typography>
        </Button>
        // ))
      :   <Button onClick={yesBtnClick} className={styles.red_btn}>
      <Typography variant="body1">Yes</Typography>
    </Button>}
          
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
